module.exports = __webpack_public_path__ + "static/media/install5.422b7b28.png";